import { OnInit } from '@angular/core';
var PasswordFormComponent = /** @class */ (function () {
    function PasswordFormComponent() {
        this.maskPassword = false;
    }
    PasswordFormComponent.prototype.ngOnInit = function () {
        this.actionType = sessionStorage.getItem('passwordActionType');
    };
    PasswordFormComponent.prototype.hasNumber = function (str) {
        return /\d/.test(str);
    };
    PasswordFormComponent.prototype.hasLowerCase = function (str) {
        return (/[a-z]/.test(str));
    };
    PasswordFormComponent.prototype.hasUpperCase = function (str) {
        return (/[A-Z]/.test(str));
    };
    Object.defineProperty(PasswordFormComponent.prototype, "showNoEdocMessage", {
        get: function () {
            return this.edocPromised || this.passwordForm.controls.enrollEDOC.value === 'N';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PasswordFormComponent.prototype, "showYesEdocMessage", {
        get: function () {
            return this.edocPromised || this.passwordForm.controls.enrollEDOC.value === 'Y';
        },
        enumerable: true,
        configurable: true
    });
    return PasswordFormComponent;
}());
export { PasswordFormComponent };
